import { createAction } from '@reduxjs/toolkit';

type OfferSelectedPayload = {
  offer: number;
};

const offerSelected = createAction<OfferSelectedPayload>('app/offerSelected');

export { offerSelected };
export type { OfferSelectedPayload };
